import styled from "styled-components";

export const TravelTypeButton = styled.button`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	border-radius: 2px;
	color: ${({ theme }) => theme.colors.palette.black};
	background: ${({ theme }) => theme.colors.palette.grey[20]};
	padding: ${({ theme }) => theme.spacing(2)} ${({ theme }) => theme.spacing(4)};
	gap: ${({ theme }) => theme.spacing(1)};

	&[aria-pressed="true"] {
		color: ${({ theme }) => theme.colors.palette.primary.main.contrast};
		background: ${({ theme }) => theme.colors.palette.primary.main.base};
	}
`;
